const mainSearchForm = {
  flights: "Mga Paglipad", // translated 
  tours: "Mga Paglilibot", // translated 
  hotel: "Hotel", // translated 
  hotels: "Mga Hotel", // translated 
  services: "Mga Serbisyo", // translated 
  search: "PAGHAHANAP", // translated 
  destination: "Destinasyon", // translated 
  includedServices: "Mga Kasamang Serbisyo", // translated 
  packageDuration: "Tagal ng Pakete", // translated 
  checkInOut: "Pag-check in / pag-check out", // translated 
  guests: "Mga Bisita", // translated 
  adults: "Mga Matanda", // translated 
  children: "mga bata", // translated 
  child: "Bata", // translated 
  age: "Edad", // translated 
  yearsOld: "Taong gulang", // translated 
  rooms: "Mga Kwarto", // translated 
  close: "Isara", // translated 
  searchType: "Uri ng Paghahanap", // translated 
  accommodation: "Akomodasyon", // translated 
  transfers: "Mga Paglilipat", // translated 
  toursExperiences: "Mga Paglilibot/Karanasan", // translated 
  nights: "Mga gabi", // translated 
  days: "Mga Araw", // translated 
  packageType: "Uri ng Pakete", // translated 
  tourType: "Uri ng Paglilibot", // translated 
  packages: "Mga Pakete", // translated 
  cars: "Mga Kotse", // translated 
  cruises: "Mga Cruise", // translated 
  infantsInSeat: "Mga sanggol na nakaupo", // translated 
  infantsOnLap: "Mga sanggol na nasa kandungan", // translated 
  airport: "Paliparan", // translated 
  passengers: "Mga Pasahero", // translated 
  departureReturn: "Mga petsa ng pag-alis at pagbabalik", // translated 
  origin: "Pinagmulan", // translated 
  roundTrip: "Paglalakbay Pabalik-balik", // translated 
  isRoundTrip: "Ay Round Trip", // translated 
  dream_packages: "Mga Pakete ng Pangarap", // translated 
  partying: "Pagsasalu-salo", // translated 
  thingsToDo: "Mga Dapat Gawin", // translated 
};


export default mainSearchForm;
